import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/App-Context";
import axios from "axios";

const Porch = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  // Standard Login State
  const [credentials, setCredentials] = useState({
    usernameOrEmail: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  // 2-Step Verification State
  const [needs2FA, setNeeds2FA] = useState(false);
  const [twoFACode, setTwoFACode] = useState("");
  const [pendingUsername, setPendingUsername] = useState("");

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  // Step 1: Initial Login Request
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/lgn-funcs/userLogin`,
        {
          loginVar: credentials.usernameOrEmail,
          password: credentials.password,
        },
        { withCredentials: true } // Crucial for receiving the pending 2FA cookie
      );

      // Check if the backend responded that 2FA is required (Status 206)
      if (response.data.requiresTwoStep) {
        setNeeds2FA(true);
        setPendingUsername(response.data.data.loginVar.username);
        setSuccess("Verification code sent to your email.");
        setLoading(false);
        return; // Stop here, do not log them in yet
      }

      // If no 2FA is required, log them in immediately
      setSuccess("Login successful!");
      auth.login(response.data.data.loginVar.username);
      navigate(`/TempleGrid/${response.data.data.loginVar.username}`);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Login failed. Please try again."
      );
    } finally {
      if (!needs2FA) setLoading(false);
    }
  };

  // Step 2: Verify the 6-Digit Code
  const handleVerify2FA = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/lgn-funcs/verifyTempleGridLogin2FA`,
        {
          code: twoFACode,
        },
        { withCredentials: true } // Crucial for sending the pending 2FA cookie back
      );

      // If successful, the backend clears the pending cookie and sets the real JWT
      setSuccess("Verification successful!");
      auth.login(pendingUsername);
      navigate(`/TempleGrid/${pendingUsername}`);
    } catch (err) {
      setError(err.response?.data?.error || "Invalid verification code.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="porch">
      <div className="path">zeus</div>
      <div className="door-frame">
        <div className="door-molding">
          {/* Display Messages */}
          {error && (
            <div
              style={{
                color: "red",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              {error}
            </div>
          )}
          {success && (
            <div
              style={{
                color: "green",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              {success}
            </div>
          )}

          {/* Conditional Rendering: Standard Login vs 2FA Form */}
          {!needs2FA ? (
            <form onSubmit={handleSubmit}>
              <div className="door-molding-crown">username</div>
              <div>
                <input
                  maxLength={17}
                  type="text"
                  name="usernameOrEmail"
                  id="usernameOrEmail"
                  value={credentials.usernameOrEmail}
                  onChange={handleChange}
                  required
                  placeholder="username or email"
                  className="door-molding-etching"
                  disabled={loading}
                />
              </div>
              <div className="door-molding-crown">password</div>
              <div>
                <input
                  type="password"
                  name="password"
                  id="password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  placeholder="password"
                  className="door-molding-etching"
                  disabled={loading}
                />
              </div>

              <div className="door-handle-enter">
                <button
                  className="door-handle-enter"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "loading..." : "login"}
                </button>
              </div>
              <div className="door-handle-navigate-login">
                <Link to="/signup">sign up</Link>
              </div>
            </form>
          ) : (
            <form onSubmit={handleVerify2FA}>
              <div className="door-molding-crown">verification code</div>
              <div>
                <input
                  type="text"
                  name="twoFACode"
                  id="twoFACode"
                  maxLength={6}
                  value={twoFACode}
                  onChange={(e) => setTwoFACode(e.target.value)}
                  required
                  placeholder="123456"
                  className="door-molding-etching"
                  disabled={loading}
                  style={{ textAlign: "center", letterSpacing: "3px" }}
                />
              </div>

              <div className="door-handle-enter">
                <button
                  className="door-handle-enter"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "verifying..." : "verify login"}
                </button>
              </div>
              <div className="door-handle-navigate-login">
                <button
                  type="button"
                  onClick={() => {
                    setNeeds2FA(false);
                    setError("");
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    color: "inherit",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
      <div className="greeterblock">
        <div className="greeterleft">Zeusdb &copy; TempleGrid &copy;</div>
        <div className="greeterright">z</div>
      </div>
    </div>
  );
};

export default Porch;
